export function initToggleActiveClass(itemsWrapClass, itemClass) {
    if (itemsWrapClass) {
        
        const itemsWrap = document.querySelectorAll(itemsWrapClass);
        itemsWrap.forEach(wrap => {
            const items = wrap.querySelectorAll(itemClass);
            items.forEach((item) => {
                item.addEventListener("click", () => {
                    if (!item.classList.contains("active")) {
                        item.classList.add("active");
                    } else {
                        item.classList.remove("active");
                    }
                });
            });
        })
    }
}